export const fullPageJsLicense = process.env.FULLPAGE_LICENSE_KEY || ""
